import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import DealsTitleBanner from './Banner/DealsTitleBanners';
import ListerFooter from './ListerFooter/ListerFooter';
import ListerHeader from './ListerHeader/ListerHeader';
import LocationBar from './LocationBar/LocationBar';
import PaginatedProductList from './ProductList/PaginatedProductList';
import Sidebar from './Sidebar/Sidebar';

const LargeListerLayout = () => {
	const { isDealsPage } = useSelector((state) => state);

	const { DesignSystemV3Enabled } = useSelector(
		(state) => state.featureSwitches
	);

	window.dispatchEvent(new CustomEvent('loadable-component-loaded'));

	return (
		<React.Fragment>
			<LocationBar />
			{isDealsPage && <DealsTitleBanner />}
			<div className="mx-4">
				<div
					className={classNames('flex mx-auto md:py-4', {
						'max-w-screen-2xl': DesignSystemV3Enabled,
						'max-w-screen-xl': !DesignSystemV3Enabled,
					})}
					itemScope
					itemType="http://schema.org/ItemList">
					<Sidebar />
					<div className="w-2/3 flex-grow pl-4 xl:pl-6">
						<ListerHeader />

						<PaginatedProductList />
					</div>
				</div>
			</div>
			<ListerFooter />
		</React.Fragment>
	);
};

export default LargeListerLayout;
